import { Link } from "react-router-dom";

export default function RelatedArticlesBelow({ articles = [] }) {
    const visible = articles.slice(0, 6);
    if (!visible.length) return null;

    return (
        <section className="mt-14">
            <h3 className="text-2xl font-bold mb-6">
                Related Articles
            </h3>

            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {visible.map((a) => (
                    <Link
                        key={a.id}
                        to={`/article/${a.slug}`}
                        className="group bg-white border border-red-200 rounded-xl overflow-hidden transition hover:shadow-lg"
                    >
                        <div className="h-36 bg-gray-100 overflow-hidden">
                            <img
                                src={a.images || "/placeholder.jpg"}
                                alt={a.title}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                            />
                        </div>

                        <div className="p-4">
                            <h4 className="font-semibold text-base leading-snug line-clamp-3 text-gray-900 group-hover:text-blue-600">
                                {a.title}
                            </h4>

                            <p className="mt-2 text-sm text-gray-500 line-clamp-2">
                                {a.excerpt || "Read the full article for details and updates."}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}
